import React, { Component } from 'react';
import './RegistrantsTable.css';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { HeaderSortComponent } from '../../../../../Scss/Custom/ReactTable/HeaderSortComponent';
import { getInverseOrder, getRegistrantsData } from '../../../../../Utils/TableUtil';
import PropTypes from 'prop-types';
import { getRegistrantsTableColumnOptions } from '../../../../../Components/CheckedMenu/CheckedMenuItemsHelper';
import SimpleSearchBox from '../../../../../Components/SearchBox/SimpleSearchBox';
import CheckedMenu from '../../../../../Components/CheckedMenu/CheckedMenu';
import { actions } from '../../../../../Reducks/SessionRegistrants';
import Pagination from '@getgo/chameleon-react/dist/Pagination';
import { REGISTRANTS_SEARCH, SESSION_DETAILS } from '../../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import { RegistrantsTableColumns } from '../../../../../Utils/Constants';
import { toggleElement } from '../../../../../Utils/ArrayUtils';

export class RegistrantsTable extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    session_registrants: PropTypes.object,
    sessionKey: PropTypes.any,
    requestRegistrants: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      visibleColumns: [
        RegistrantsTableColumns.REGISTRATION_TIME,
        RegistrantsTableColumns.UNSUBSCRIBED,
        RegistrantsTableColumns.STATUS,
        RegistrantsTableColumns.SOURCE
      ],
      currentPage: 1
    };
  }

  onClickHandler = updateId =>
    this.setState(prevState => ({ visibleColumns: toggleElement(updateId, prevState.visibleColumns) }));

  render() {
    const { fetching, registrants, page } = this.props.session_registrants;
    const { currentPage } = this.state;
    const { isBig } = this.props;
    const mixpanelData = {
      action: SESSION_DETAILS,
      searchType: REGISTRANTS_SEARCH
    };
    const { t } = this.context;
    const detailsMenu = getRegistrantsTableColumnOptions().map(item => {
      return {
        onClick: () => this.onClickHandler(item.id),
        text: item.title,
        id: `registrantTableMenuItem_${item.id}`,
        checked: this.state.visibleColumns.includes(item.id)
      };
    });
    return (
      <div className="registrantsTableSection">
        <div className="searchRow">
          <SimpleSearchBox
            searchString={this.props.session_registrants.filter.textSearch}
            placeHolder={t('sessionDetails.searchRegistrants')}
            onSearchInputChange={this.handleSearch}
            mixpanelData={mixpanelData}
          />
          <CheckedMenu
            menuKey="manageColumns"
            detailsMenu={detailsMenu}
            buttonName={t('sessionDetails.manageColumns')}
            isBig={isBig}
          />
        </div>
        {registrants && (
          <React.Fragment>
            {this.getRegistrantsTable(registrants, fetching)}
            <div className="pagination">
              <Pagination
                key="registration-table-pagination"
                pageIndex={currentPage}
                lastPage={Math.ceil(page.totalElements / page.size)}
                previousDisabled={currentPage === 1}
                nextDisabled={currentPage === Math.ceil(page.totalElements / page.size)}
                onNextSelected={() => this.fetchMoreRegistrants({ pageNumber: currentPage + 1 })}
                onPreviousSelected={() => this.fetchMoreRegistrants({ pageNumber: currentPage - 1 })}
                onPageSelected={page => this.fetchMoreRegistrants({ pageNumber: page })}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }

  fetchMoreRegistrants(options = {}) {
    const { requestRegistrants, sessionKey, session_registrants } = this.props;
    const {
      pageNumber = this.state.currentPage,
      textSearch = session_registrants.filter.textSearch,
      sortBy = session_registrants.sort.sortBy,
      sortOrder = session_registrants.sort.sortOrder
    } = options;
    this.setState({ currentPage: pageNumber }, () =>
      requestRegistrants(sessionKey, pageNumber - 1, { textSearch }, { sortOrder, sortBy })
    );
  }

  handleSearch = value => {
    if (value !== null) {
      this.fetchMoreRegistrants({ pageNumber: 1, textSearch: value });
    }
  };

  getRegistrantsTable = (registrants, fetching) => {
    return (
      <ReactTable
        keyField="registrantKey"
        data={getRegistrantsData(registrants)}
        columns={this.getRegistrantsColumns()}
        loading={fetching}
        defaultPageSize={50}
        minRows={5}
        style={{ height: '270px' }}
        showPagination={false}
        className="-highlight"
        sortable={false}
      />
    );
  };

  emailCellFormatter = ({ original }) => <a href={`mailto:${original.email}`}>{original.email}</a>;

  getRegistrantsColumns = () => {
    const { t } = this.context;
    const { session_registrants } = this.props;
    const sortBy = session_registrants.sort.sortBy;
    const sortOrder = session_registrants.sort.sortOrder;

    return [
      {
        accessor: 'firstName',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.firstName')}
            onClick={() => {
              this.fetchMoreRegistrants({
                sortBy: RegistrantsTableColumns.GIVEN_NAME,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === RegistrantsTableColumns.GIVEN_NAME ? sortOrder : null}
          />
        ),
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' },
        minWidth: 200
      },
      {
        accessor: 'lastName',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.lastName')}
            onClick={() => {
              this.fetchMoreRegistrants({
                sortBy: RegistrantsTableColumns.SUR_NAME,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === RegistrantsTableColumns.SUR_NAME ? sortOrder : null}
          />
        ),
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' },
        minWidth: 200
      },
      {
        accessor: 'email',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.email')}
            onClick={() => {
              this.fetchMoreRegistrants({
                sortBy: RegistrantsTableColumns.EMAIL,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === RegistrantsTableColumns.EMAIL ? sortOrder : null}
          />
        ),
        Cell: this.emailCellFormatter,
        minWidth: 200,
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' }
      },
      {
        accessor: 'registrationDateAndTime',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.registrationDateAndTime')}
            onClick={() => {
              this.fetchMoreRegistrants({
                sortBy: RegistrantsTableColumns.REGISTRATION_TIME,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === RegistrantsTableColumns.REGISTRATION_TIME ? sortOrder : null}
          />
        ),
        show: this.state.visibleColumns.includes(RegistrantsTableColumns.REGISTRATION_TIME),
        minWidth: 250,
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' }
      },
      {
        accessor: 'unsubscribed',
        Header: <HeaderSortComponent headerTitle={t('sessionDetails.unsubscribed')} />,
        show: this.state.visibleColumns.includes(RegistrantsTableColumns.UNSUBSCRIBED),
        Cell: ({ value }) => String(value),
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' },
        minWidth: 200
      },
      {
        accessor: 'status',
        Header: <HeaderSortComponent headerTitle={t('sessionDetails.status')} />,
        show: this.state.visibleColumns.includes(RegistrantsTableColumns.STATUS),
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' },
        minWidth: 200
      },
      {
        accessor: 'source',
        Header: <HeaderSortComponent headerTitle={t('sessionDetails.source')} />,
        show: this.state.visibleColumns.includes(RegistrantsTableColumns.SOURCE),
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' },
        minWidth: 200
      }
    ];
  };
}

export default connect(
  state => ({
    session_registrants: state.reduced_session_registrants
  }),
  {
    requestRegistrants: actions.getSessionRegistrantsDetails
  }
)(RegistrantsTable);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Table/RegistrantsTable/RegistrantsTable.js